import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { Spinner, Logo } from "../../components";
import { Users } from "../../users/users";
import { firebaseAuth, googleProvider } from "../../config/firebase";
import { Logout } from "../../services/users.service";

import { Button, IconLogin, Layout, Wrapper } from "./Login.styles";

const checkIsAdmin = (uid) =>
  Users.filter((user) => user.uid === uid).length > 0 ? true : false;

export const Login = () => {
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);
  const user = useSelector((store) => store.user);
  const dispatch = useDispatch();

  const loginSuccess = (user) => {
    const { uid, displayName, photoURL, email } = user;

    dispatch({
      type: "USER_LOGIN_SUCCESS",
      user: {
        name: displayName,
        uid,
        image: photoURL,
        email,
      },
    });
  };

  const loginWithGoogle = () => {
    setLoading(true);

    firebaseAuth
      .signInWithPopup(googleProvider)
      .then((result) => {
        const { user } = result;

        if (checkIsAdmin(user.uid)) {
          loginSuccess(user);
          setLoading(false);
        } else {
          setErr("Account not found");
          setLoading(false);
          dispatch({ type: "LOGOUT_USER" });
          Logout();
        }
      })
      .catch((err) => {
        setErr("Algo deu errado. Tente novamente mais tarde. | " + err);
        setLoading(false);
        dispatch({ type: "LOGOUT_USER" });

        setTimeout(() => {
          setErr(null);
        }, 5000);
      });
  };

  return user?.isLogged ? (
    <Redirect to="/artigos" />
  ) : (
    <Layout>
      <Wrapper>
        <IconLogin>
          <LockOutlinedIcon />
        </IconLogin>
        <Logo />
        {loading && <Spinner />}
        {err && <span> {err}</span>}
        <Button disabled={loading} onClick={loginWithGoogle}>
          continuar com google
        </Button>
      </Wrapper>
    </Layout>
  );
};

export default Login;
